<template>
    <div v-if="display" class="row">
        <div class="col">
            <SubSection title="Options now you have built a plan" :show-help="false">
                <p>
                    There are lots of ways we can help now you have built a plan. For those that don't want to pay for 
                    advice, we show some chosen low cost providers who may be suitable to put all your pots together 
                    with. For those that want to take advice we show some vetted advisers you can seek advice from. For 
                    those that want to buy some guaranteed income, we show some annuity brokers who can help get you 
                    the best deal.
                </p>
                <p>
                    Some of our partners license our tech and we have commercial arrangements with them to do so, but we 
                    do not take any referral fees from them should you choose them.
                </p>
            </SubSection>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import SubSection from "../common/SubSection.vue";

const store = useStore();
const display = ref(false);

onMounted(() => {
    display.value = store.state.configuration.finishDisplaysOptionsNowYouHaveAPlan;
});

</script>
